export const DocumentEditorContainer = 'documenteditorcontainer';
export const Pager = 'pager';
export const Grid = 'grid';
export const Dropdowns = 'dropdowns';
export const DocumentEditor = 'documenteditor';
export const DatePicker = 'datepicker';
export const DateTimePicker = 'datetimepicker';
export const RichTextEditor = 'richtexteditor';
export const ColorPicker = 'colorpicker';
export const Schedule = 'schedule';
export const RecurrenceEditor = 'recurrenceeditor';
export const Dates = 'dates';
export const Calendar = 'calendar';
